import { render, staticRenderFns } from "./StatsStaffRegistrationsModal.vue?vue&type=template&id=513b128c&"
import script from "./StatsStaffRegistrationsModal.vue?vue&type=script&lang=js&"
export * from "./StatsStaffRegistrationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports